import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalProps } from '../types';

interface Modal {
  modalName: string;
  modalParams?: string;
  modalOrder?: number;
  modalVariant?: ModalProps['variant'];
  shouldCloseOnEscape?: boolean;
}
type ModalsSliceState = {
  openModals: Modal[];
};

const initialState: ModalsSliceState = {
  openModals: [],
};

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    reset: () => initialState,
    addOpenModal: (state: ModalsSliceState, action: PayloadAction<Modal>) => {
      if (state.openModals.find((m) => m.modalName === action.payload.modalName)) {
        // remove existing one
        state.openModals = state.openModals.filter(
          (m) => m.modalName !== action.payload.modalName
        );
      }

      const orderedModals = state.openModals.sort(
        (a, b) => (b.modalOrder ?? 0) - (a.modalOrder ?? 0)
      );
      const nextModalOrder = orderedModals?.length
        ? (orderedModals[0].modalOrder ?? 0) + 1
        : 1;

      // add
      state.openModals.push({
        ...action.payload,
        modalOrder: nextModalOrder,
      });
    },
    removeOpenModal: (state: ModalsSliceState, action: PayloadAction<string>) => {
      state.openModals = state.openModals.filter((m) => m.modalName !== action.payload);
    },
  },
});

export const { addOpenModal, removeOpenModal } = modalsSlice.actions;

export default modalsSlice;
